export interface InvitationDTO extends InvitationBasicDTO {
  id?: string;
  status?: string;
  creationDate?: Date;
  expiryDate?: Date;
}

export interface InvitationBasicDTO {
  firstName: string;
  lastName: string;
  email: string;
  gender: string;
}

export interface InvitationLinkInfo {
  entiteId: string,
  idnInvitor: string,
  token: string,
}

export interface VerifiedInvitation extends InvitationBasicDTO {
  id: string,
  isExpired: boolean,
  entityName: string,
  entityId: string,
  callback: string,
}

export const InvitationPopinEnum = {
  CONFIRMATION: 'CONFIRMATION',
  DELETE: 'DELETE',
  RENEW: 'RENEW',
} as const;

export type InvitationPopinEnum = typeof InvitationPopinEnum[keyof typeof InvitationPopinEnum];

export const REJECTED_STATUS = 'REJECTED';
